module.exports = __webpack_public_path__ + "static/media/contact1.610dd6f3.jpg";